import React, { useCallback, useEffect, useImperativeHandle, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter, useLocation } from 'react-router-dom'
import { DigitalVaultHomeView } from '../../views'

function DigitalVaultHomeAction(props) {
  const { toggleErrorRequesting, viewAsCards, setViewAsCards, tabRef } = props

  const { state } = useLocation()
  const [companies, setCompanies] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [subcategoryPath, setSubcategoryPath] = useState([])
  const [subcategoryId, setSubcategoryId] = useState('')
  const [selectedDocument, setSelectedDocument] = useState(null)

  const [documentId, setDocumentId] = useState('')
  const [fileManagerPath, setFileManagerPath] = useState('/')
  const [breadcrumbItems, setBreadcrumbItems] = useState([])

  useEffect(() => {
    if (state) {
      setSelectedCompany(state.selectedCompany)
      setSelectedCategory(state.selectedCategory)
      setSubcategoryPath(Array.isArray(state.subcategoryPath) ? state.subcategoryPath : [])
      setFileManagerPath(state.fileManagerPath)
      if (state.documentId) {
        setDocumentId(state.documentId)
      }
    } else {
      setFileManagerPath('/')
    }
  }, [state])

  function createFileManagerPath({ items }) {
    const newArr = items.splice(1)
    return `/${newArr.map((i) => i.id).join('/')}/`
  }

  const handleBreadcrumbClick = (event, item) => {
    event.preventDefault()
    if (item.id === 0) {
      setFileManagerPath('/')
      setDocumentId('')
    } else {
      const path = createFileManagerPath({
        items: breadcrumbItems
      })

      setFileManagerPath(path)
      setDocumentId('')
    }
  }

  function goBack() {
    const path = createFileManagerPath({
      items: breadcrumbItems
    })

    setFileManagerPath(path)
    setDocumentId('')
  }

  const newDocument = useCallback(() => {
    const pathArr = Array.isArray(subcategoryPath) ? subcategoryPath : []
    const subPath = pathArr
      .map((i) => i?.subcategory?.id ?? i?.id ?? i)
      .filter((v) => v !== undefined && v !== null && v !== '')
      .join(',')

    return {
      companyId: selectedCompany?.company?.id,
      categoryId: selectedCategory?.id,
      subcategoryPath: subPath,
    }
  }, [subcategoryPath, selectedCategory, selectedCompany])

  const clearData = useCallback(() => {
    setSelectedCompany(null)
    setSelectedCategory(null)
    setSubcategoryPath([])
    setSelectedDocument(null)
  }, [])

  useImperativeHandle(tabRef, () => ({ newDocument, clearData }), [newDocument, clearData])

  return (
    <DigitalVaultHomeView
      toggleErrorRequesting={toggleErrorRequesting}
      viewAsCards={viewAsCards}
      setViewAsCards={setViewAsCards}
      breadcrumbItems={breadcrumbItems}
      setBreadcrumbItems={setBreadcrumbItems}
      handleBreadcrumbClick={handleBreadcrumbClick}
      companies={companies}
      setCompanies={setCompanies}
      selectedCompany={selectedCompany}
      setSelectedCompany={setSelectedCompany}
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
      selectedDocument={selectedDocument}
      setSelectedDocument={setSelectedDocument}
      subcategoryPath={subcategoryPath}
      setSubcategoryPath={setSubcategoryPath}
      subcategoryId={subcategoryId}
      setSubcategoryId={setSubcategoryId}
      documentId={documentId}
      setDocumentId={setDocumentId}
      fileManagerPath={fileManagerPath}
      setFileManagerPath={setFileManagerPath}
      goBack={goBack}
    />
  )
}

export default withRouter(withTranslation()(DigitalVaultHomeAction))
